import React from "react";
import GenericMasterPage from "@/pages/GenericMasterPage";

export default function DeviceModelsPage() {
  return (
    <GenericMasterPage
      resourcePath="device-models"
      testIdPrefix="device-model"
      title="Device Model"
      description="GPS / telematics device manufacturers and models."
      fields={[
        { key: "manufacturer", label: "Manufacturer", required: true, placeholder: "e.g. Teltonika" },
        { key: "model", label: "Model", required: true, placeholder: "e.g. FMB920" },
      ]}
      displayKeys={["manufacturer", "model"]}
    />
  );
}
